'use strict';

module.exports = {
  hits: require('./hits.js'),
  popularIn: require('./popularIn.js')
};



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/src/sources/index.js
// module id = 866
// module chunks = 1